import { spacing, spaceProp, marginBottomSpacing } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import { useWindowWidth } from '@react-hook/window-size';
import { useRef, useState, useEffect, createElement } from 'react';
import styled, { css } from 'styled-components';
import { StyledLink } from '../../Link/Link.js';
import { StyledButton } from '../Button.js';

const StyledButtonGroup = styled.div `
  display: inline-flex;
  align-items: center;

  ${StyledButton}, ${StyledLink} {
    ${({ glue, isToSmall }) => glue && !isToSmall && css `
      &:not(:last-child):not(:first-child) {
        border-radius: 0;
      }

      :last-child {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
      }

      :first-child {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }
    `};

    ${({ isToSmall }) => isToSmall && `
      margin-bottom: ${spacing(4)};
    `};
    ${({ spacing, isToSmall }) => spacing && !isToSmall && spaceProp(spacing, 'marginRight')};

    :last-child {
      margin-right: 0;
    }
  }

  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const ButtonGroup = withExtra(({ children, glue, spacing, spaceAfter, className }) => {
    const ref = useRef();
    const onlyWidth = useWindowWidth({ wait: 300 });
    const [isToSmall, setIsToSmall] = useState(false);
    useEffect(() => {
        if (window) {
            const maxWidth = ref.current.offsetWidth;
            const children = ref.current.children;
            let width = 0;
            for (let i = 0; i < children.length; i++) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                width += children.item(i).offsetWidth;
            }
            setIsToSmall(maxWidth < width);
        }
    }, [setIsToSmall, ref, onlyWidth]);
    return (createElement(StyledButtonGroup, { className: className, glue: glue, isToSmall: isToSmall, ref: ref, spacing: spacing, spaceAfter: spaceAfter }, children));
}, { name: 'ButtonGroup' });

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.js.map
